export default __webpack_public_path__ + "static/media/Location-Red-24x24.5fd5ea89.svg";